exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes rotation-data-v-55e5133a{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}.icon[data-v-55e5133a]{position:relative;display:inline-flex;width:1em;height:1em;align-items:center;justify-content:center}.icon__base[data-v-55e5133a]{fill:transparent;stroke:currentColor;stroke-opacity:.4;stroke-width:3}.icon__rotate[data-v-55e5133a]{animation-duration:600ms;animation-iteration-count:infinite;animation-name:rotation-data-v-55e5133a;animation-timing-function:ease-in-out;position:absolute;top:0;left:0;fill:transparent;stroke:currentColor;stroke-width:3;transform-origin:center}", ""]);

// exports
